import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["display"]
  static values = {
    tableId: String
  }

  connect() {
    this.observeTableChanges()
    this.updateCount()

    // Listen for Turbo Stream events which are more reliable than MutationObserver
    this.boundTurboHandler = this.handleTurboStream.bind(this)
    document.addEventListener("turbo:before-stream-render", this.boundTurboHandler)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.boundTurboHandler) {
      document.removeEventListener("turbo:before-stream-render", this.boundTurboHandler)
    }
  }

  handleTurboStream(event) {
    const target = event.target
    // Check if stream action affects our table (remove or append to tbody)
    const streamTarget = target.getAttribute("target")
    if (streamTarget && (streamTarget.includes("team_member") || streamTarget === this.tableIdValue)) {
      // Schedule update after Turbo has processed the stream
      requestAnimationFrame(() => this.updateCount())
    }
  }

  /**
   * Sets up a MutationObserver to watch for changes in the table body
   * @private
   */
  observeTableChanges() {
    const tbody = document.getElementById(this.tableIdValue)
    if (!tbody) return

    this.observer = new MutationObserver(() => {
      this.updateCount()
    })

    this.observer.observe(tbody, {
      childList: true,
      subtree: true
    })
  }

  /**
   * Counts the rows in the table and updates the display
   * Excludes empty state rows from the count; leden die het zoekfilter verbergt
   * staan in data-member-count-offset en tellen mee
   * @private
   */
  updateCount() {
    const tbody = document.getElementById(this.tableIdValue)
    if (!tbody || !this.hasDisplayTarget) return

    const rows = tbody.querySelectorAll('tr:not([id*="empty_state"])')
    const count = rows.length + parseInt(tbody.dataset.memberCountOffset || "0", 10)

    const countSpan = this.displayTarget.querySelector("span.font-medium")
    if (countSpan) {
      countSpan.textContent = count
    }
  }
}
